module.exports = __webpack_public_path__ + "9d78fea9775d905232e16e743671e3bf.jpg";